import React, { useEffect, useState, useMemo, useCallback } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const Receivers = ({emails, setEmails, customStyles}) => {

    const [email, setEmail] = useState('')

    const addEmail = (e) => {
        e && e.preventDefault()
        if (!email) return
        if (emails.includes(email)) return
        setEmails([...emails, email])
        setEmail('')
    }

    const removeEmail = (index) => {
        setEmails(emails.filter((email, i) => i !== index))
    }

    return (
        <div className="setting-form-config-section">
            <h3>Receivers</h3>
            <div className="setting-form-email-list">
                {
                    emails.map((email, index) => (
                        <div key={index} className='setting-form-email-item'>
                            <div type="email">{email}</div>
                            <div onClick={() => removeEmail(index)}><DeleteOutlineIcon/></div>
                        </div>))
                }
            </div>
            <form onSubmit={addEmail} className="setting-form-email-input-group">
                <input
                    className="setting-form-email-input" 
                    type="email"
                    placeholder="Enter email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button type='submit' className='setting-form-add-email-btn'>Add Email</button>
            </form>
        </div>
    )
}

export default Receivers;